<div
  class="flex flex-col items-center justify-center min-h-screen bg-gray-100 text-center p-4"
>
  <h2 class="text-3xl font-extrabold text-gray-800 mb-6">
    404 - Seite nicht gefunden
  </h2>
</div>
